const URL = "http://imaster-001-site3.dtempurl.com/";
// const URL = "https://localhost:5001/";

export default URL;